import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { TherapeuticIndicationApi } from '../../../apis/TherapeuticIndicationApi/TherapeuticIndicationApi';

export function useGetResourceUrl(therapeuticIndicationId: number | undefined) {
    const { i18n } = useTranslation();
    return useQuery<string>({
        queryKey: [QueryKeys.therapeuticIndication, 'resourceUrl', therapeuticIndicationId, i18n.language],
        queryFn: () => TherapeuticIndicationApi.getResourceUrl(therapeuticIndicationId!),
        enabled: !!therapeuticIndicationId,
    });
}
